var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 55,
    viewBox: "0 0 120 55",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .a{\n    fill:none;\n  }\n  .b{\n    fill:#53BE93;\n  }\n  .c{\n    fill:#1DB4CF;\n  }\n  .d{\n    fill:#FFF;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35 -33)translate(35 33)",
    className: "undefined"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 28.1L40 28.1C38.1 27 37.4 24.6 38.5 22.8L50.4 2.2C51.5 0.3 53.9-0.3 55.7 0.8 57.6 1.8 58.2 4.3 57.2 6.1L45.3 26.7C44.2 28.5 41.8 29.2 40 28.1",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7 27.9L79.7 27.9C81.5 26.8 82.2 24.4 81.1 22.5L69.2 2C68.2 0.1 65.8-0.6 63.9 0.5 62 1.6 61.4 4 62.5 5.9L74.3 26.4C75.4 28.3 77.8 28.9 79.7 27.9",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 28.6L68 28.6C69.9 27.5 70.5 25.1 69.4 23.2L63.2 12.4C62.1 10.5 59.7 9.8 57.8 10.9 56 12 55.3 14.4 56.4 16.3L62.7 27.1C63.7 29 66.2 29.7 68 28.6",
    className: "b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44)",
    className: "d"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 10.1 0 0.2 3 0.2 4.8 6.9 6.6 0.2 9.6 0.2 9.6 10.1 7.7 10.1 7.7 2.3 5.7 10.1 3.8 10.1 1.9 2.3 1.9 10.1",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.2 10.1 16.2 10.1 16.2 0.2 14.2 0.2",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.1C22.5 6.2 22.8 7.1 23.3 7.7 23.8 8.2 24.5 8.5 25.3 8.5 26.1 8.5 26.7 8.2 27.3 7.7 27.8 7.1 28 6.2 28 5.1 28 3.9 27.8 3.1 27.3 2.5 26.8 2 26.1 1.7 25.3 1.7 24.5 1.7 23.8 2 23.3 2.6 22.8 3.1 22.5 4 22.5 5.1M20.5 5.2C20.5 4.2 20.6 3.3 20.9 2.6 21.2 2.1 21.5 1.7 21.9 1.3 22.3 0.9 22.7 0.6 23.1 0.4 23.8 0.1 24.5 0 25.3 0 26.7 0 27.9 0.5 28.8 1.4 29.6 2.3 30.1 3.5 30.1 5.1 30.1 6.7 29.6 8 28.8 8.9 27.9 9.8 26.8 10.2 25.3 10.2 23.8 10.2 22.7 9.8 21.8 8.9 20.9 8 20.5 6.7 20.5 5.2",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9 6.8L35.8 6.7C36 7.3 36.2 7.8 36.6 8.1 36.9 8.4 37.4 8.5 38 8.5 38.6 8.5 39.1 8.4 39.5 8.1 39.8 7.9 39.9 7.5 39.9 7.2 39.9 6.9 39.9 6.8 39.7 6.6 39.6 6.4 39.4 6.3 39 6.2 38.8 6.1 38.2 5.9 37.4 5.7 36.3 5.5 35.6 5.1 35.2 4.7 34.6 4.2 34.3 3.5 34.3 2.8 34.3 2.3 34.4 1.8 34.7 1.3 35 0.9 35.4 0.6 35.9 0.3 36.5 0.1 37.1 0 37.9 0 39.1 0 40 0.3 40.7 0.8 41.3 1.4 41.6 2.1 41.7 3L39.7 3.1C39.6 2.6 39.4 2.2 39.1 2 38.8 1.8 38.4 1.7 37.8 1.7 37.3 1.7 36.8 1.8 36.5 2 36.3 2.2 36.2 2.4 36.2 2.6 36.2 2.9 36.3 3.1 36.5 3.2 36.7 3.4 37.3 3.7 38.3 3.9 39.3 4.1 40 4.4 40.4 4.6 40.9 4.8 41.3 5.2 41.5 5.6 41.8 6 41.9 6.6 41.9 7.2 41.9 7.7 41.8 8.3 41.5 8.8 41.1 9.3 40.7 9.6 40.1 9.9 39.6 10.1 38.8 10.2 38 10.2 36.7 10.2 35.8 9.9 35.1 9.4 34.4 8.8 34 7.9 33.9 6.8",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53 10.1 53 0.2 55 0.2 55 4.1 58.9 4.1 58.9 0.2 60.9 0.2 60.9 10.1 58.9 10.1 58.9 5.7 55 5.7 55 10.1",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.7 10.1 65.7 0.2 73 0.2 73 1.8 67.7 1.8 67.7 4 72.7 4 72.7 5.7 67.7 5.7 67.7 8.4 73.2 8.4 73.2 10.1",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9 6.1L81.6 2.5 80.2 6.1 82.9 6.1ZM86.6 10.1L84.4 10.1 83.6 7.8 79.6 7.8 78.8 10.1 76.7 10.1 80.5 0.2 82.6 0.2 86.6 10.1Z",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.5 10.1 90.5 0.2 92.5 0.2 92.5 8.4 97.4 8.4 97.4 10.1",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.8 10.1 102.8 1.8 99.9 1.8 99.9 0.2 107.8 0.2 107.8 1.8 104.8 1.8 104.8 10.1",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.8 10.1 111.8 0.2 113.8 0.2 113.8 4.1 117.7 4.1 117.7 0.2 119.7 0.2 119.7 10.1 117.7 10.1 117.7 5.7 113.8 5.7 113.8 10.1",
    className: "undefined"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/icLogo.dfab3f9659b3183819c686e783b7b80d.svg";
export { ForwardRef as ReactComponent };